var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"white--text text-center text-h1 h1-text"},[_vm._v(" Deslogueado ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }